/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LusdUsdtAsUnderlying,
  LusdUsdtAsUnderlyingInterface,
} from "../LusdUsdtAsUnderlying";

const _abi = [
  {
    inputs: [],
    name: "LUSD_INDEX_LUSD3CRV_POOL",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "UNKNOWN_AMOUNT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "USDT_INDEX",
    outputs: [
      {
        internalType: "int128",
        name: "",
        type: "int128",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60ba610039600b82828239805160001a60731461002c57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe730000000000000000000000000000000000000000301460806040526004361060455760003560e01c806173f414604a5780637d9149fc146064578063bccda83114607d575b600080fd5b6051600181565b6040519081526020015b60405180910390f35b606b600081565b604051600f9190910b8152602001605b565b606b60038156fea264697066735822122061de163d8c53cdb4f5be29b0f8177d65913c2dd3747e993baa98db1e7a24beb164736f6c634300080d0033";

type LusdUsdtAsUnderlyingConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: LusdUsdtAsUnderlyingConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class LusdUsdtAsUnderlying__factory extends ContractFactory {
  constructor(...args: LusdUsdtAsUnderlyingConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "LusdUsdtAsUnderlying";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LusdUsdtAsUnderlying> {
    return super.deploy(overrides || {}) as Promise<LusdUsdtAsUnderlying>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): LusdUsdtAsUnderlying {
    return super.attach(address) as LusdUsdtAsUnderlying;
  }
  connect(signer: Signer): LusdUsdtAsUnderlying__factory {
    return super.connect(signer) as LusdUsdtAsUnderlying__factory;
  }
  static readonly contractName: "LusdUsdtAsUnderlying";
  public readonly contractName: "LusdUsdtAsUnderlying";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LusdUsdtAsUnderlyingInterface {
    return new utils.Interface(_abi) as LusdUsdtAsUnderlyingInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LusdUsdtAsUnderlying {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LusdUsdtAsUnderlying;
  }
}
